
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinelectroniccity() {



    const cardData =
    {
        keyword: '  Cab Service in Electronic City Bangalore',
        heading: 'etravo : Cab Service in Electronic City Bangalore',



"headingDescription": "eTravo offers reliable Cab Services in Electronic City Bangalore, designed for IT companies, MNCs, startups, and professionals who require seamless transportation for daily office commute, employee pickup and drop, airport transfers, client meetings, and executive travel. With GPS-enabled vehicles, professional chauffeurs, and flexible corporate plans, eTravo ensures safe, punctual, and comfortable mobility across Electronic City and nearby tech corridors.",

"top": "Top Corporate Cab Service Areas in Electronic City Bangalore with eTravo",

"topPlaces": [
  {
    "title": "Electronic City Phase 1",
    "description": "A major IT hub with global tech companies and corporate offices requiring structured employee pickup and drop services for daily shifts."
  },
  {
    "title": "Electronic City Phase 2",
    "description": "Home to large IT parks and MNCs where corporate cab services are essential for workforce mobility and shift-based transportation."
  },
  {
    "title": "Infosys Campus Electronic City",
    "description": "A major tech campus area with high employee traffic requiring reliable and scheduled corporate cab services."
  },
  {
    "title": "Wipro Campus Electronic City",
    "description": "A key corporate zone with large employee strength where daily commute and shuttle services are widely used."
  },
  {
    "title": "Hosur Road Corridor",
    "description": "A major connectivity route linking Electronic City to central Bangalore, heavily used for corporate travel and office commute."
  },
  {
    "title": "Bommasandra Industrial Area",
    "description": "An industrial and tech-support zone near Electronic City requiring workforce transportation and shift-based cab services."
  },
  {
    "title": "Neeladri Nagar",
    "description": "A residential hub for IT employees working in Electronic City, requiring daily office commute cab services."
  },
  {
    "title": "Velankani Tech Park",
    "description": "A corporate campus area hosting IT companies requiring reliable employee transportation and executive travel."
  },
  {
    "title": "HCL & Tech Mahindra Campus Zone",
    "description": "A high-density corporate area where structured cab services are essential for employee mobility."
  },
  {
    "title": "Attibele–Electronic City Corridor",
    "description": "A key suburban route used by IT professionals commuting daily to Electronic City for work."
  }
],


"services": [
{
"name": "Cab Electronic City Bangalore",
"description": "eTravo offers reliable cab services in Electronic City Bangalore for smooth and comfortable travel. Our service ensures punctual pickups, clean vehicles, and professional drivers for daily commuting and business travel."
},
{
"name": "Taxi Electronic City Bangalore",
"description": "Our taxi services in Electronic City Bangalore provide quick and dependable transportation for professionals and residents. eTravo ensures timely service and hassle-free travel across IT hubs and nearby areas."
},
{
"name": "Corporate Cab Electronic City",
"description": "eTravo provides corporate cab services in Electronic City tailored for IT companies and businesses. Our service ensures reliable employee transport and executive travel with professional service standards."
},
{
"name": "Office Transport Electronic City",
"description": "Simplify employee commuting with eTravo’s office transport services in Electronic City. We offer structured and efficient pickup and drop solutions for corporate offices."
},
{
"name": "Employee Cab Electronic City Bangalore",
"description": "Our employee cab services in Electronic City Bangalore are designed for safe and punctual commuting. eTravo ensures smooth daily travel with well-maintained vehicles and experienced drivers."
},
{
"name": "Company Cab Electronic City",
"description": "eTravo offers company cab services in Electronic City for reliable employee and executive transportation. Our service ensures flexibility, safety, and consistent travel experiences."
},
{
"name": "Business Taxi Electronic City",
"description": "eTravo’s business taxi services in Electronic City are ideal for meetings, client visits, and corporate travel. Our service ensures punctuality and professional travel experiences."
},
{
"name": "Staff Transport Electronic City Bangalore",
"description": "eTravo provides dependable staff transport services in Electronic City Bangalore for daily commuting. Our service ensures timely pickups and safe travel for employees."
},
{
"name": "Corporate Travel Electronic City",
"description": "Our corporate travel services in Electronic City cover both local and outstation business needs. eTravo ensures reliable and comfortable journeys for executives and teams."
},
{
"name": "Pickup Drop Electronic City Bangalore",
"description": "eTravo offers pickup and drop services in Electronic City Bangalore for convenient daily commuting. Our service ensures punctual scheduling and smooth travel experiences."
},
{
"name": "Office Cab Booking Electronic City",
"description": "Book office cabs in Electronic City easily with eTravo. Our service ensures reliable vehicles, timely pickups, and hassle-free travel for corporate teams."
},
{
"name": "Corporate Commute Electronic City",
"description": "eTravo’s corporate commute services in Electronic City provide structured and efficient employee transportation. Our service ensures smooth daily travel for IT professionals."
},
{
"name": "Professional Cab Electronic City",
"description": "eTravo offers professional cab services in Electronic City with trained drivers and well-maintained vehicles. Our service ensures safe and comfortable travel for all needs."
},
{
"name": "IT Park Cab Electronic City",
"description": "eTravo provides IT park cab services in Electronic City for companies and employees. Our service ensures reliable transport within major IT hubs and business centers."
},
{
"name": "Daily Cab Electronic City",
"description": "eTravo offers daily cab services in Electronic City Bangalore for regular commuting. Our service ensures consistent, punctual, and comfortable travel for office-goers and professionals."
}
],
"tableData": [
["Cab Electronic City Bangalore", "Taxi Electronic City Bangalore"],
["Corporate Cab Electronic City", "Office Transport Electronic City"],
["Employee Cab Electronic City Bangalore", "Company Cab Electronic City"],
["Business Taxi Electronic City", "Staff Transport Electronic City Bangalore"],
["Corporate Travel Electronic City", "Pickup Drop Electronic City Bangalore"],
["Office Cab Booking Electronic City", "Corporate Commute Electronic City"],
["Professional Cab Electronic City", "IT Park Cab Electronic City"],
["Daily Cab Electronic City", ""]
],




"whychoose": [
    {
      "WhyChooseheading": "Reliable Cab Service in Electronic City Bangalore",
      "WhyChoosedescription": "eTravo offers dependable cab service in Electronic City Bangalore, ensuring smooth and efficient transportation for daily commuters, IT professionals, and business travelers."
    },
    {
      "WhyChooseheading": "Perfect for IT Hub and Corporate Travel",
      "WhyChoosedescription": "Electronic City is one of India’s largest IT hubs with companies like Infosys, Wipro, and HCL, making reliable cab services essential for daily commuting and corporate travel. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "24/7 Cab Availability for All Travel Needs",
      "WhyChoosedescription": "Cab services in Electronic City operate round the clock, allowing users to book rides anytime for office commute, airport transfers, and business meetings. :contentReference[oaicite:1]{index=1}"
    },
    {
      "WhyChooseheading": "Wide Range of Vehicles for Every Requirement",
      "WhyChoosedescription": "Cab providers offer hatchbacks, sedans, SUVs, and premium cars suitable for individual travel, corporate use, and group transportation. :contentReference[oaicite:2]{index=2}"
    },
    {
      "WhyChooseheading": "Professional Drivers with Local Expertise",
      "WhyChoosedescription": "Experienced drivers with knowledge of Electronic City routes ensure safe, timely, and efficient travel, even during peak traffic hours."
    },
    {
      "WhyChooseheading": "Affordable and Flexible Travel Options",
      "WhyChoosedescription": "Cab services provide hourly, daily, and outstation booking options, making them suitable for both short trips and long-distance travel. :contentReference[oaicite:3]{index=3}"
    },
    {
      "WhyChooseheading": "Ideal for Airport Transfers and Business Travel",
      "WhyChoosedescription": "Electronic City cab services are widely used for airport pickups, corporate travel, and client meetings, offering convenience and reliability."
    },
    {
      "WhyChooseheading": "Safe, Clean, and Well-Maintained Vehicles",
      "WhyChoosedescription": "All vehicles are regularly serviced and sanitized, ensuring safety, hygiene, and comfort for passengers."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is cab service in Electronic City Bangalore?',
            answer: 'Cab service in Electronic City Bangalore provides local, outstation, and airport transportation for residents, employees, and business travelers.',
        },
        {
            question: 'Are cab services available 24/7 in Electronic City?',
            answer: 'Yes, most cab providers operate 24/7, allowing bookings at any time for office commute or travel needs. :contentReference[oaicite:4]{index=4}',
        },
        {
            question: 'Can I book cabs for office pickup and drop?',
            answer: 'Yes, cab services offer daily office pickup and drop solutions for employees working in Electronic City. :contentReference[oaicite:5]{index=5}',
        },
        {
            question: 'What types of vehicles are available for booking?',
            answer: 'Vehicles include hatchbacks, sedans, SUVs, and tempo travellers depending on travel requirements. :contentReference[oaicite:6]{index=6}',
        },
        {
            question: 'Are cab services suitable for airport transfers?',
            answer: 'Yes, Electronic City cab services provide airport pickup and drop services for both domestic and international travel.',
        },
        {
            question: 'Is cab service safe in Electronic City Bangalore?',
            answer: 'Yes, services include verified drivers, GPS tracking, and regular vehicle maintenance to ensure safe travel.',
        },
        {
            question: 'Can I book cabs for outstation travel from Electronic City?',
            answer: 'Yes, cab services provide one-way and round-trip outstation travel options from Electronic City. :contentReference[oaicite:7]{index=7}',
        },
        {
            question: 'Do cab services offer corporate travel solutions?',
            answer: 'Yes, many providers offer corporate cab services including employee transport and business travel. :contentReference[oaicite:8]{index=8}',
        },
        {
            question: 'How can I book a cab in Electronic City Bangalore?',
            answer: 'You can book through mobile apps, websites, or by contacting customer support for quick reservations. :contentReference[oaicite:9]{index=9}',
        },
        {
            question: 'Are cab services affordable in Electronic City?',
            answer: 'Yes, there are multiple options available ranging from budget to premium, making cab services accessible for all users.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Naveen Kumar',
        designation: 'Software Engineer, Electronic City Bangalore',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo provides excellent cab service in Electronic City. Their punctual pickups and professional drivers make my daily commute hassle-free.”',
    },
    {
        name: 'Ms. Priya Nair',
        designation: 'HR Executive, IT Company, Bangalore',
        rating: [1, 1, 1, 1, 1],
        text: '“We use eTravo for corporate travel in Electronic City. Their reliable service and clean vehicles ensure a comfortable journey every time.”',
    },
];



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Electronic City Bangalore",
  "image": "https://www.etravo.in/images/keyword/cab-electronic-city-bangalore.jpg",
  "description": "Reliable cab service in Electronic City, Bangalore by eTravo. Ideal for IT employees, office commute, corporate travel, staff transport, and daily pickup and drop services with safe and timely rides.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-in-electronic-city-bangalore"
  }
};




    return (
        <div>

<Helmet>
  <title>Cab Service in Electronic City Bangalore | IT & Office Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book cab service in Electronic City Bangalore with eTravo for IT employee transport, office commute, corporate travel, and daily pickup and drop services. Safe and reliable rides." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/152.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinelectroniccity;